/* import __COLOCATED_TEMPLATE__ from './loan-balances.hbs'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { Target } from '@banking/ui/utils/launchpad-cdp-events';
import Component from '@glimmer/component';
import { action } from '@ember/object';
let LoanBalances = (_class = class LoanBalances extends Component {
  get isMcaGlobal() {
    return this.args.isMcaGlobal;
  }
  get loanOffers() {
    const offers = [];
    this.args.loansAndOffers.forEach(loan => {
      if (loan?.loanOfferDetails) {
        offers.push(loan.loanOfferDetails);
      }
    });
    return offers;
  }
  get loansAndOffers() {
    return this.args.loansAndOffers.map(loan => ({
      ...loan,
      shouldShowLoanRow: loan.hasLoan && !loan.isInactive || !loan.loanOfferDetails
    }));
  }
  goToLoanOffer(offer, event) {
    event.stopPropagation();
    this.args.goToCapitalLoanOffer(offer.offerSetId, {
      target: Target.BalanceCardViewOffer,
      unitToken: offer.unitToken
    });
  }
  goToLoan(customerToken, unitToken) {
    this.args.goToCapitalLoan({
      customerToken,
      unitToken
    });
  }
}, _applyDecoratedDescriptor(_class.prototype, "goToLoanOffer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToLoanOffer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToLoan", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToLoan"), _class.prototype), _class);
export { LoanBalances as default };